"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorSubstitutesListApiResponseSchema = exports.getDoctorSubstituteItemApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.getDoctorSubstituteItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitutes'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
        createdAt: zod_1.z.coerce.date(),
        priority: zod_1.z.number().int().nullable().optional(),
        installable: zod_1.z.boolean().nullable().optional(),
        isAvailable: zod_1.z.boolean().optional(),
    }),
});
exports.getDoctorSubstitutesListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorSubstituteItemApiResponseSchema);
